module.exports = "../../app/cells/components/modals/setup_cell.rb";